import { BrowserRouter, Route, Routes } from "react-router-dom";
import Emplogin from "./pages/emplogin/Emplogin";
import { AuthProvider } from './context/AuthContext';
import { NavigationProvider } from './context/NavigationContext';
import { useState } from "react";
import Hoddashboard from './pages/hoddashboard/Hoddashboard'
import CreateMrf from './pages/createmrf/CreateMrf'
import ChooseRole from "./pages/hr/chooserole/ChooseRole"
import HrDashboard from "./pages/hr/hrdashboard/HrDashboard";
import OnboardHr from "./pages/onboarding/onboard_hr/OnboardHr";
import Candidateform from "./pages/candidateform/Candidateform";
import EmployeeDashboard from "./pages/employee/EmployeeDashboard";
import PreOnboardingForm from "./pages/onboarding/preonboard/PreOnboardingForm";
import CandidateOfferResponse from "./pages/candidateofferresponse/CandidateOfferResponse";
import TlChange from "./pages/hr/TlChange";
import ChangeTl from "./pages/payroll/ChangeTl";
import EmpTransferResponse from "./pages/EmpTransferResponse";
import PayrollHr from "./pages/payroll/payrollhr/PayrollHr"
import AttendanceCapture from "./components/attendance/AttendanceCapture";
import AttendanceLog from "./pages/AttendanceLog";
import EmpIdCard from "./components/EmpIdCard";
import ViewEmpAttendance from "./components/attendance/viewEmpAttendance";
import PaySlip from "./components/PaySlip";
import BirthDayTemplate from "./components/BirthDayTemplate";
import WeddingAnniversary from "./components/WeddingAnniversary";
import ViewBirthDay from "./components/ViewBirthDay";
import WorkAnniversary from "./components/WorkAnniversary";
import WorkCard from "./components/WorkCard";
import ChangePassword from "./pages/ChangePassword";
import IosSupport from "./components/IosSupport";
import SendMail from "./components/SendMail";
import TeamList from "./components/TeamList";
import AppPolicyInfo from "./components/AppPolicyInfo";
import PrivacyPolicy from "./components/PrivacyPolicy";

import AIChatBot from "./pages/AIChatBot";
import MyCompoffs from "./pages/payroll/MyCompoffs";
import Overlay from "./components/overlay/Overlay";
import FinalApprovalDetail from "./pages/hr/FinalApprovalDetail";

function App() {
  // const [overlayDone, setOverlayDone] = useState(false);

  // if (!overlayDone) {
  //   return <Overlay onComplete={() => setOverlayDone(true)} />;
  // }

  return (
    <BrowserRouter>
      <AuthProvider>
        <NavigationProvider>
          <Routes>
            {/* Public routes (no auth needed) */}
            <Route path="/account-deletion" element={<AppPolicyInfo />} />
            <Route path="/bemss-support" element={<IosSupport />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            {/* Auth-protected routes */}
            <Route path="" element={<Emplogin />} />
            <Route path="/hod" element={<Hoddashboard />} />
            <Route path="/employee" element={<EmployeeDashboard />} />
            <Route path="/createmrf" element={<CreateMrf />} />
            <Route path="/chooserole" element={<ChooseRole />} />
            <Route path="/hrdashboard" element={<HrDashboard />} />
            <Route path="/onboard_hr" element={<OnboardHr />} />
            <Route path="/payroll_hr" element={<PayrollHr />} />
            <Route path="/candidate-form/:c_id/" element={<Candidateform />} />
            <Route path="/offer-responses/:cid" element={<CandidateOfferResponse />} />
            <Route path="/transfer-response/:token" element={<EmpTransferResponse />} />
            <Route path="/hr/tl-change" element={<TlChange />} />
            <Route path="/hr/change-tl" element={<ChangeTl />} />
            <Route path="/candidate-preonboarding-form/:cid" element={<PreOnboardingForm />} />
            <Route path="/attendance" element={<AttendanceCapture />} />
            <Route path="/attendance/log" element={<ViewEmpAttendance />} />
            <Route path="/employee_id/:empid" element={<EmpIdCard />} />
            <Route path="/change_password" element={<ChangePassword />} />
            <Route path="/chatbot" element={<AIChatBot />} />
            <Route path="/hr/compoffs/my" element={<MyCompoffs />} />
            <Route path="/exit-process/:exitProcessId/final-approval" element={<FinalApprovalDetail />} />
          </Routes>
        </NavigationProvider>
      </AuthProvider>
    </BrowserRouter >
  );
}

export default App;
